export default __webpack_public_path__ + "static/media/qr_student_homepage.1064c3a8.png";